// extracted by mini-css-extract-plugin
module.exports = {"read-more":"read-more-review_read-more___4r9k"};